import type { SolutionDataRequirementsApi } from '@ipen-portal/backstage-plugin-solution-data-requirements-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const solutionDataRequirementApiRef = createApiRef<
  TRPCOptionsProxy<SolutionDataRequirementsApi>
>().with({
  id: 'plugin.ipen.solution.data.requirement.api',
});
